import { FunctionComponent, useCallback, MouseEvent } from "react";
import { IconButton, ScrollableSwimlane } from "@ppb/the-wall-web";
import styles from "./SportRibbonCardGroup.web.css";
import { CardItem, ComponentProps } from "./props";
import { i18n } from "../../helpers/i18n";
import { TranslationKey } from "../../translations/keys";
import FunAndGaming from "./snowflakes/FunAndGaming.web";
import { SportRibbonLayout } from "@ppb/tbd-store/clients/catalogue/catalogue-response-types";

const SportRibbonCardGroup: FunctionComponent<ComponentProps> = ({
  urn,
  items,
  isSportsRibbonHighlighted,
  ribbonLayout,
  title,
  getIcon,
  dispatchRouterPushAction,
  dispatchNavigationViewFromFavourites,
}) => {
  const onClick = useCallback(
    (event: MouseEvent, { viewLink, title }: (typeof items)[number]) => {
      event.preventDefault();
      dispatchRouterPushAction(viewLink);
      dispatchNavigationViewFromFavourites(title, viewLink.viewUrl, urn);
    },
    [dispatchNavigationViewFromFavourites, dispatchRouterPushAction, urn],
  );

  const hasTags = items.some((item) => item.label);

  const renderCard = (item: CardItem) => {
    switch (ribbonLayout) {
      /**
       * This layout is used to display fun and gaming ribbon on PP only, based on Prismic config
       */
      case SportRibbonLayout.Secondary:
        return (
          <FunAndGaming
            icon={getIcon(item.icon, item.badge, item.sportId)}
            tag={hasTags ? item.label || "" : undefined}
            text={i18n({ key: item.title as keyof TranslationKey })}
            onPress={(e) => onClick(e, item)}
          />
        );
      case SportRibbonLayout.Primary:
      default:
        return (
          <IconButton
            icon={getIcon(item.icon, item.badge, item.sportId)}
            text={i18n({ key: item.title as keyof TranslationKey })}
            isLargeIcon
            isHighlighted={hasTags || isSportsRibbonHighlighted}
            onPress={(e) => onClick(e, item)}
            tag={hasTags ? item.label || "" : undefined}
          />
        );
    }
  };

  return (
    <ScrollableSwimlane isHighlighted={isSportsRibbonHighlighted} title={title || undefined}>
      {items.map((item, index) => (
        <div key={`${urn}-${index}`} className={styles.sportViewLink}>
          {renderCard(item)}
        </div>
      ))}
    </ScrollableSwimlane>
  );
};

export default SportRibbonCardGroup;
